export default __webpack_public_path__ + "static/media/userManagement.59f4f2f2.svg";